module.exports = __webpack_public_path__ + "static/sterling_395x344-b5d2b0ad62957525353d47044e3f6789.png";